import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueSidebarMenu from "vue-sidebar-menu";
import Multiselect from "vue-multiselect";
import vuetify from "@/plugins/vuetify";
import ComponentPlugin from "@/components/_ComponentPlugin";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import Vuelidate from "vuelidate";
import Treeselect from "@riophae/vue-treeselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

library.add(fas);
library.add(fab);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("multiselect", Multiselect);
Vue.component("treeselect", Treeselect);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSidebarMenu);
Vue.use(ComponentPlugin);
Vue.use(CKEditor);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
